export default __webpack_public_path__ + "static/media/arrow-grey-right.33cd5c5d.svg";